import React from 'react';

import { TranslateFunction } from 'react-localize-redux';

import { ErrorBoundary } from '../../../../App/ErrorBoundary';
import { MenuItemsList } from '../../../../components/organisms/MenuItemsList';
import { Currency } from '../../../../core/api/general/general.types';
import { MenuItem } from '../../../../core/api/menu/menu.types';
import { QuantityControlType } from '../../../../core/types/basket.types';
import { useCrossSellList } from './hooks/useCrossSellList';

export type Props = {
  addItemToBasket: QuantityControlType['onAddItem'];
  className?: string;
  crossSellMenuItems: MenuItem[];
  currency: Currency;
  isLoading: boolean;
  languageCode: string;
  translate: TranslateFunction;
};

export function CrossSellList(props: Props): JSX.Element {
  const {
    addItemToBasket,
    className = 'fd-cross-sell-list',
    crossSellMenuItems,
    currency,
    isLoading,
    languageCode,
    translate,
  } = props;

  const { crossSellList, isDesktopScreen, onHandleAddItem, showCrossSellList } =
    useCrossSellList(addItemToBasket, crossSellMenuItems, isLoading, translate);

  if (!showCrossSellList) {
    return null;
  }

  return (
    <ErrorBoundary identifier="cross-sell-list">
      <MenuItemsList
        className={className}
        currency={currency}
        hasGreyBackground
        isLoading={isLoading}
        languageCode={languageCode}
        menuItems={crossSellList}
        onAddItem={onHandleAddItem}
        title={translate('CrossSell_peopleAlsoAdded') as string}
        translate={translate}
        variant={isDesktopScreen ? 'grid' : 'compact'}
      />
    </ErrorBoundary>
  );
}
